(function(){
     'use strict';

     angular
        .module('appback')
        .factory('ChatService', ChatService);

    ChatService.$inject = ['$http'];

    function ChatService($http){

        var service= {
           getMisCategorias:getMisCategorias,
           enviarMensaje:enviarMensaje,
           getMensajesSala:getMensajesSala
        };

        return service;
 		function getMisCategorias(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/chat/getmiscategorias', { params : {  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getMensajesSala(vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/chat/getmensajessala', { params : { type:vm.typeChat, room:vm.salaActual } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function enviarMensaje(mensaje,callback)
        {

        	var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    ignoreLoadingBar: true, 
                },
                ignoreLoadingBar: true, 
            }
            var data = $.param({
               ignoreLoadingBar: true, 
               mensaje:JSON.stringify(mensaje)
            });
            $http.post('/backend/chat/enviarmensaje', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

      
    }
})();